document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("form.customProductForm");
  // console.log("Mounted R Script");
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    }).then(res => {
      // console.log("cart emptied");
      
    }).catch(error => {
      console.error(error)
    })
  
  window.theme = window.theme || {};
  // Avoid double-instantiation
  window.theme.cartDrawer = window.theme.cartDrawer || new theme.CartDrawer();
  
  if (form) {
    form.addEventListener("submit", onFormSubmit);
  }

  async function onFormSubmit(e){
    // console.log("Form Submitted")
    const formData = new FormData(form)
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    const data = Object.fromEntries(formData.entries());
    const id = data.id;
    console.log(id);

    // {
    //   id: "45537782857946",
    //   quantity: 1,
    //   properties: {
    //     "message": "Gift"
    //   }
    // }

    const giftID = "45537782857946"
    const discount = "?discount=FLARECAREDUOBONUS"
    
    if(id == "46750062215386"){

      const payload = {
        items: [
          { id: id, quantity: 1 },
          ...(giftID ? [{ id: giftID, quantity: 1, properties: { _gift: 'true' } }] : [])
        ]
      };

const base = `${id}:1`
const gift = "45537782857946:1"
      window.location = `https://mymagichealer.com/cart/${base}${discount}`
      // await fetch('/cart/add.js', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify(payload)
      //   })
      //   .then(response => {
      //     console.log(response.json);
      //     fetch('/cart/update.js', {

      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     body: JSON.stringify({
          
      //       discount: 'FLARECAREDUOBONUS',
          
      //     })
      //   }).then(res => {
      //     // console.log(res.json);
      //     window.theme.cartDrawer.init();
      //     window.theme.cartDrawer.open();
          
      //   }).catch((error) => {
      //     console.error('Error:', error);
      //   });
      // })
      // .catch((error) => {
      //   console.error('Error:', error);
      // });
    } else {
const base = `${id}:1`

      window.location = `https://mymagichealer.com/cart/${base}${discount}`
      
      // await fetch('/cart/add.js', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   body: JSON.stringify({
      //     'items': [
      //       {
      //     'id': id,
      //     'quantity': 1,
      //     }
      //   ]
      //   })
      // })
      // .then(response => {
      //   // console.log(response.json())
      //   window.theme.cartDrawer.init();
      //   window.theme.cartDrawer.open();

      // })
      // .catch((error) => {
      //   console.error('Error:', error);
      // });
    }

  }

  const inputs = Array.from(document.querySelectorAll(".singleCardInput"));
  const priceBox = document.querySelector(".grid-product__price__custom");

  function updatePrice(price, compare, currency) {
    
    let html = `<span class="price">${price} ${currency}</span>`;
    if (compare && compare !== "" && compare !== price) {
      html += `<span class="compare">${compare} ${currency}</span>`;
    }
    priceBox.innerHTML = html;
  }

  inputs.forEach(input => {
    input.addEventListener("change", () => {
        
      if (input.checked) {
        const price = input.dataset.price;
        const compare = input.dataset.compare;
        const c = input.dataset.currency;
        // console.log(c);
        
        updatePrice(price, compare, c);
      }
    });
  });

  if(window.innerWidth < 1100){
   
    (function(){
      const track = document.querySelector('.customLargeCards');
      const slides = Array.from(track.children);
      const dotsWrap = document.getElementById('dots');
    
      slides.forEach((s, i) => {
        const b = document.createElement('button');
        b.setAttribute('tabindex', -1)
        b.addEventListener('click', () => snapTo(i, true));
        s.addEventListener('click', () => snapTo(i, true));

        dotsWrap.appendChild(b);
      });
      const dots = Array.from(dotsWrap.children);
    
      let index = 0;
      let slideW = slides[0].getBoundingClientRect().width + gap();
      let x = 0;
      let startX = 0, baseX = 0;
      let velocity = 0, lastT = 0, lastX = 0;
      let dragging = false;
    
      function gap(){ return parseFloat(getComputedStyle(track).gap || 0); }
      function setTransform(px, animate=false){
        track.style.transition = animate ? 'transform 350ms ease' : 'none';
        track.style.transform = `translate3d(${px}px,0,0)`;
      }
      function updateDots(){ dots.forEach((d,i)=>d.setAttribute('aria-current', i===index)); }
      function clamp(v,min,max){ return Math.max(min,Math.min(max,v)); }
    
      track.addEventListener('touchstart', (e)=>{
        if (e.touches.length !== 1) return;
        dragging = true;
        startX = e.touches[0].clientX;
        baseX = x;
        lastX = startX;
        lastT = performance.now();
        velocity = 0;
        setTransform(x, false);
      });
    
      track.addEventListener('touchmove', (e)=>{
        if (!dragging) return;
        const dx = e.touches[0].clientX - startX;
        x = baseX + dx;
        setTransform(x, false);
    
        // track velocity
        const now = performance.now();
        const dt = now - lastT;
        if (dt > 0){
          velocity = (e.touches[0].clientX - lastX) / dt;
          lastX = e.touches[0].clientX;
          lastT = now;
        }
      }, { passive: true });
    
      track.addEventListener('touchend', ()=>{
        if (!dragging) return;
        dragging = false;
        const momentum = velocity * 200; // tweak swipe sensitivity
        const projected = -(x + momentum) / slideW;
        index = clamp(Math.round(projected), 0, slides.length-1);
        x = -index * slideW;
        setTransform(x, true);
        updateDots();
      });
    
      function snapTo(i, animate){
        index = clamp(i,0,slides.length-1);
        x = -index * slideW;
        setTransform(x, animate);
        updateDots();
      }
    
      window.addEventListener('resize', ()=>{
        slideW = slides[0].getBoundingClientRect().width + gap();
        snapTo(index,false);
      });
    
      snapTo(0,false);
    })();
  }
});
